import { Navigate, useLocation } from "react-router-dom";


const ProtectedRoute = ({ children, isAuthenticated, completeProfile, showReferalPage }) => {

	const location = useLocation();

    if (!isAuthenticated) {
    	if( location.pathname )
    		localStorage.setItem("backUrl", location.pathname);
        return <Navigate to="/login" replace />;
    }

    return children;
}

export default ProtectedRoute;
